"use client"

import clsx from "clsx"
import { Suspense } from "react"
import { npPagePbClassName, npPagePxClassName } from "src/components/np-design/components/constants"
import { ListProductData } from "src/data/product-list/types"
import { AdcellSearchTag } from "../../integrations/adcell/AdcellSearchTag"
import { ProductList } from "./ProductList"
import { ProductListAction } from "./ProductListItem"
import { SearchForm } from "./SearchForm"
import { useProductSearch } from "./useProductSearch"

export type FilterableProductListProps = {
  listId: string
  products: ListProductData[]
  action?: ProductListAction
}

const _FilterableProductList = ({ action, listId, products }: FilterableProductListProps) => {
  const { query, delayedValue, setQuery, hits } = useProductSearch(listId, products)

  return (
    <>
      <div className={clsx(npPagePxClassName, npPagePbClassName, "mx-auto w-full max-w-xl")}>
        <SearchForm value={query} onChange={(value) => setQuery(products, value)} />
      </div>

      <ProductList listId={listId} products={hits} action={action} />
      <AdcellSearchTag input={delayedValue} products={hits} />
    </>
  )
}

export const FilterableProductList = (props: FilterableProductListProps) => (
  <Suspense>
    <_FilterableProductList {...props} />
  </Suspense>
)
